import type { ScreenSchema } from './types';

const gridQuestionSchema: ScreenSchema = {
  template: 'grid-question',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    },
    feedback: { parts: [{ field: 'feedback' }] },
    'feedback-correct': { parts: [{ field: 'feedback.correct' }] },
    'feedback-incorrect': { parts: [{ field: 'feedback.incorrect' }] },
    'feedback-retry': { parts: [{ field: 'feedback.retry' }] },
    'feedback-retry-final': { parts: [{ field: 'feedback.retry-final' }] }
  }
};

export default gridQuestionSchema;
